import { render, staticRenderFns } from "./ProcurationSteps.vue?vue&type=template&id=2fee632f&scoped=true&"
import script from "./ProcurationSteps.vue?vue&type=script&lang=js&"
export * from "./ProcurationSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fee632f",
  null
  
)

export default component.exports